import * as React from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import ShowCase from 'aquilla/core/molecules/ShowCase';
import pushRoute from '@utils/pushRoute';
import NewCourseCard from '@cont/EnrolledCourse/NewCourseCard';
import { Spacings } from '../../../styleConstants';

interface ICourseBlock {
  goalUID: string;
  courseData: any;
}

const Wrapper = styled(ShowCase)`
  grid-column: span 18;
  margin-top: ${Spacings.SPACING_5B};
`;

const CourseBlock: React.FC<ICourseBlock> = ({ goalUID, courseData = {} }) => {
  const { results = [] } = courseData;
  const router = useRouter();
  const { goalSlug } = router.query;

  if (results.length === 0) return null;

  const handleSeeAll = () => {
    const route = {
      href: '/goal/[goalSlug]/[goalUID]/enrolled/courses',
      as: `/goal/${goalSlug}/${goalUID}/enrolled/courses`
    };
    pushRoute(route.href, route.as);
  };

  return (
    <Wrapper
      title="Courses"
      itemsPerSlide={3}
      onSeeAll={results.length > 3 ? handleSeeAll : null}
    >
      {results.slice(0, 3).map((course) => (
        <NewCourseCard course={course} key={course.uid} />
      ))}
    </Wrapper>
  );
};

export default CourseBlock;
